const _require = require('@truqc/content-path'),
  keysSortedByValueDescriptors = _require.keysSortedByValueDescriptors;
const _require2 = require('../lib/evaluateSource'),
  evaluateSource = _require2.evaluateSource;
const _require3 = require('../lib/getFormContent'),
  getFormContent = _require3.getFormContent;

/**
  * @function evalute - evaluate selectionTitlesBehavior
  */

const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions) => {
  const sourceEvaluator = source2 => evaluateSource(source2, content, parentContentPath, transientContext, nativeFunctions);
  const selection = await sourceEvaluator(source.value);
  if (selection === undefined) {
    return undefined;
  }
  const pedigreeSeparator = await sourceEvaluator(source.pedigreeSeparator);
  const leaves = [];
  const traverse = async (subtree, ancestors) => {
    const sortDescriptors = [{
      path: '_created',
      ascending: true
    }, {
      path: 'title',
      ascending: true
    }];
    const keys = keysSortedByValueDescriptors(subtree, sortDescriptors);
    for (let i = 0; i < keys.length; i += 1) {
      const key = keys[i];
      let value = subtree[key];
      const _value = value,
        children = _value.children,
        newFormID = _value._formRef;
      if (newFormID !== undefined) {
        // eslint-disable-next-line no-await-in-loop
        value = await getFormContent(newFormID, content, parentContentPath, transientContext, nativeFunctions);
      }
      const _value2 = value,
        _value2$title = _value2.title,
        title = _value2$title === void 0 ? '?' : _value2$title;
      const current = [...ancestors, title];
      if (children === undefined) {
        leaves.push(pedigreeSeparator === undefined ? title : current.join(pedigreeSeparator));
      } else {
        // eslint-disable-next-line no-await-in-loop
        await traverse(children, current);
      }
    }
  };
  await traverse(selection, []);
  return leaves;
};
module.exports = {
  evaluate
};